import React from 'react'
import { inject, observer } from 'mobx-react'

import Input from '../../../generic/Input'
import FormRenderer from '../../../generic/FormRenderer';
import MultiSelect from '../../../generic/MultiSelect';
import MaskedInput from '../../../generic/MaskedInput';

const EditCompaniesForm = inject('configCompaniesStore', 'productsStore')(observer(props => {
  const { configCompaniesStore, productsStore } = props
  const { name, cnpj, products } = configCompaniesStore.state.selectedCompany
  const availableProducts = productsStore.state.products
  console.log(products)
  const formFields = [{
    component: Input,
    label: 'Nome',
    type: 'text',
    name: 'name',
    id: 'edit-company-name',
    placeholder: 'Nome',
    value: name
  },{
    component: MaskedInput,
    label: 'CNPJ',
    type: 'text',
    name: 'cnpj',
    id: 'edit-user-cnpj',
    placeholder: 'CNPJ',
    maskFunction: () => [/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/],
    value: cnpj
  },{
    component: MultiSelect,
    label: 'Produtos',
    placeholder: 'Adicionar produtos',
    value: products.map(data => {
      return {value: data, label: data}
    }),
    options: availableProducts.map(data => {
      return {value: data.name, label: data.name}
    }),
    onChange: selectedOptions => configCompaniesStore.setSelectedProducts(selectedOptions)
  }]
  return (
    <form>
      <FormRenderer fields={formFields} store={configCompaniesStore} />
    </form>
  )
}))

export default EditCompaniesForm



// WEBPACK FOOTER //
// ./src/components/dashboard/config/companies/EditCompaniesForm.js